import styled from 'styled-components';

export const Wrapper = styled.div`
  background-color: #020410;
  min-width: ${props => props.width === '30%'? '450px' : '0%'};
  width: ${props => props.width};
  height: 100%;
  position: relative;
`;